import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { saveSearchParam, getPageIndex, getPageSize, getFiltered, getSorted } from 'helpers/filterHelper';

export const ClearFilterButton = ({reactTable, style}) => {
    return (
        <Button
        outline color="secondary"
        style={style}
        onClick={() => {
            reactTable.state.filtered = [];
            reactTable.state.sorted = [];
            reactTable.state.page = 0;
            reactTable.fireFetchData();
        }}
        >
            Clear Filters
        </Button>
    );
//   return (
//     <button
//       type={type}
//       disabled={disabled}
//       onClick={onClick}
//       className="app-button"
//     >
//       {label}
//     </button>
//   );
};

// ClearFilterButton.propTypes = {
//     // reactTable: PropTypes.object.isRequired,
//     // storageKey: PropTypes.string.isRequired,
// //   type: PropTypes.oneOf(['button', 'submit', 'reset']),
// };